import once from 'lodash/once'

export default once(function showInfoInConsole({
  platform,
  nativeVersion,
  accountName,
  spaVersion,
}) {
  if (process.env.NODE_ENV !== 'development') {
    const nativeAppInfo =
      (platform &&
        nativeVersion &&
        `${platform.toUpperCase()} - v${nativeVersion}`) ||
      ''
    console.log(`
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=
 __         _________ __
|__| ____  /   _____//  |_  ___________   ____
|  |/    \\ \\_____  \\\\   __\\/  _ \\_  __ \\_/ __ \\
|  |   |  \\/        \\|  | (  <_> )  | \\/\\  ___/
|__|___|  /_______  /|__|  \\____/|__|    \\___

  ${nativeAppInfo} ✨ ${accountName} - v${spaVersion}
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=
      `)
  }
})
